// This file configures the initialization of Sentry on the client.
// The added config here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/article/:category\",\"regex\":\"^/article/([^/]+)$\",\"paramNames\":[\"category\"],\"hasOptionalPrefix\":false},{\"path\":\"/article/:category/:slug\",\"regex\":\"^/article/([^/]+)/([^/]+)$\",\"paramNames\":[\"category\",\"slug\"],\"hasOptionalPrefix\":false}],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/about\"},{\"path\":\"/archive\"},{\"path\":\"/article\"},{\"path\":\"/contact\"},{\"path\":\"/contribution\"},{\"path\":\"/mentions-legales\"},{\"path\":\"/politique-de-confidentialite\"},{\"path\":\"/recherche\"}],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.3.1";globalThis["_sentryRewritesTunnelPath"] = "/monitoring";import * as Sentry from "@sentry/nextjs";

Sentry.init({
  dsn: "https://b3a49e7786bdd928457eafa90db11e00@o4510399373180928.ingest.de.sentry.io/4510510807842896",

  // Add optional integrations for additional features
  integrations: [Sentry.replayIntegration()],

  // Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
  tracesSampleRate: 1,
  // Enable logs to be sent to Sentry
  enableLogs: true,

  // Define how likely Replay events are sampled.
  // This sets the sample rate to be 10%. You may want this to be 100% while
  // in development and sample at a lower rate in production
  replaysSessionSampleRate: 0.1,

  // Define how likely Replay events are sampled when an error occurs.
  replaysOnErrorSampleRate: 1.0,

  // Enable sending user PII (Personally Identifiable Information)
  // https://docs.sentry.io/platforms/javascript/guides/nextjs/configuration/options/#sendDefaultPii
  sendDefaultPii: true
});

export const onRouterTransitionStart =
  Sentry.captureRouterTransitionStart;
